import React, { useState, useEffect, useRef } from "react";
import { SourceItem, SourceTxt, Popup, PopupItem } from "./style";
import PdfIcon from "../../assets/pdf.svg";
import DocxIcon from "../../assets/docx.svg";
import TxtIcon from "../../assets/txt.svg";
import WhiteCircle from "../../assets/white-circle.svg";
import DottedMenu from "../../assets/kebab-menu.svg";
import ChunkModal from "../modals/ChunkModal";

const SourceCard = ({ cardText, documentType, onClick, chunk = "", url = "" }) => {
  const [showDetailsModal, setshowDetailsModal] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const popupRef = useRef(null);

  const handleshowDetailsModal = () => {
    setshowDetailsModal(true);
    setShowPopup(false);
  };

  const handleHideDetailsModal = () => {
    setshowDetailsModal(false);
  };

  const handleOpenDocument = () => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
      setShowPopup(false);
    } else {
      console.warn("No URL provided for document");
    }
  };

  const handleTalkToDocument = () => {
    onClick();
    setShowPopup(false);
  };

  let displayImg;
  let backgroundColor;

  switch (documentType) {
    case "pdf":
      displayImg = PdfIcon;
      backgroundColor = "#E5252A";
      break;
    case "doc":
    case "docx":
      displayImg = DocxIcon;
      backgroundColor = "#1757B7";
      break;
    case "txt":
      displayImg = TxtIcon;
      backgroundColor = "#2C93D4";
      break;
    default:
      displayImg = PdfIcon;
      backgroundColor = "#E5252A";
      break;
  }

  const truncatedCardText =
    cardText.length > 19 ? `${cardText.substring(0, 19)}...` : cardText;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <SourceItem style={{ backgroundColor }}>
        <img
          src={DottedMenu}
          alt="menu"
          style={{
            width: "1rem",
            height: "0.8rem",
            position: "absolute",
            right: "0.2rem",
            top: "0.5rem",
            zIndex: "1",
            cursor: "pointer",
          }}
          onClick={() => setShowPopup(!showPopup)}
        />
        <Popup isOpen={showPopup} ref={popupRef}>
          <PopupItem onClick={handleOpenDocument}>Open Document</PopupItem>
          <PopupItem onClick={handleTalkToDocument}>Talk to Document</PopupItem>
          <PopupItem onClick={handleshowDetailsModal}>Details</PopupItem>
        </Popup>
        <SourceTxt>{truncatedCardText}</SourceTxt>
        <div
          style={{
            display: "flex",
            gap: "0.19rem",
            marginTop: "auto",
            position: "relative",
          }}
        >
          <img src={WhiteCircle} alt="doctype" />
          <img
            src={displayImg}
            alt="document icon"
            style={{
              position: "absolute",
              top: "50%",
              transform: "translate(8%, -49%)",
            }}
          />
        </div>
      </SourceItem>
      {showDetailsModal && (
        <ChunkModal onClose={handleHideDetailsModal} chunk={chunk} />
      )}
    </>
  );
};

export default SourceCard;